import { callAPI } from "../../lib/common";
export class WebshopApiClient {
    getPromotedProducts() {
        return callAPI("/api/webshop/promoted-products");
    }
    getPackages(subjectUuid, mobile = false) {
        let url = "/ajax/prophoto/get_packages.php?uuid=" + subjectUuid;
        if (mobile) {
            url += "&mobile=1";
        }
        return callAPI(url);
    }
    getPriceList() {
        return callAPI("/api/webshop/user/pricelist");
    }
    getInitialPricelist() {
        var _a;
        if (typeof window === "undefined")
            return null;
        const w = window;
        return (_a = w.NTLF_PRICE_LIST) !== null && _a !== void 0 ? _a : null;
    }
    getCurrentUser() {
        return callAPI("/ajax/user/get_user.php");
    }
    getTemplateData(uuid, version = null) {
        let url = "/api/webshop/templates/by-uuid/" + uuid;
        if (version) {
            url += "/" + version;
        }
        return callAPI(url);
    }
    getPictureSets() {
        return callAPI("/ajax/user/get_picture_sets.php");
    }
    getCatalogues() {
        return callAPI("/ajax/user/get_catalogues.php");
    }
}
